export default __webpack_public_path__ + "static/media/REFIN_PRESTIGIO_STATUARIO_APUANO_CRAQUELE.cb8e2f3f.jpg";